import { useCallback } from "react";

import { useIntl } from "react-intl";
import { graphql, useMutation } from "react-relay";
import { useAlert } from "../../../../common/Alert";
import { useDeleteStorecastMutation } from "./__generated__/useDeleteStorecastMutation.graphql";

export function useDeleteStorecast(props: {
  storecastId: string;
  storecastTitle: string;
  onCompleted(): void;
}) {
  const intl = useIntl();
  const [deleteStorecast, loading] = useMutation<useDeleteStorecastMutation>(
    graphql`
      mutation useDeleteStorecastMutation($storecastId: ID!) {
        deleteDashboard(id: $storecastId) {
          id @deleteRecord
        }
      }
    `
  );

  const onDeleteStorecast = useCallback(() => {
    deleteStorecast({
      variables: { storecastId: props.storecastId },
      onCompleted: props.onCompleted,
    });
  }, [deleteStorecast, props.onCompleted, props.storecastId]);

  const Alert = useAlert();
  const onPress = useCallback(() => {
    Alert.alert(
      intl.formatMessage(
        {
          defaultMessage: `Are you sure that you want to delete "{storecastTitle}"?`,
          description:
            "StorecastSettingsBottomSheet delete storecast confiramation alert title",
        },
        {
          storecastTitle: props.storecastTitle,
        }
      ),
      intl.formatMessage({
        defaultMessage: "All Widgets will be deleted.",
        description:
          "StorecastSettingsBottomSheet delete storecast confiramation alert description",
      }),
      [
        {
          style: "destructive",
          text: intl.formatMessage({
            defaultMessage: "Delete",
            description:
              "StorecastSettingsBottomSheet delete storecast confiramation alert delete option",
          }),
          onPress: onDeleteStorecast,
        },
        {
          style: "cancel",
          text: intl.formatMessage({
            defaultMessage: "Cancel",
            description:
              "StorecastSettingsBottomSheet delete storecast confirmation alert cancel option",
          }),
        },
      ]
    );
  }, [Alert, intl, onDeleteStorecast, props.storecastTitle]);

  return [onPress, loading] as const;
}
